import React from 'react';

const RadioButton = ({ className, label, name, value, checked, onChange }) => {
  return (
    <label className={className}>
      <input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
      />
      {label}
    </label>
  );
};

export default RadioButton;
